(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TkbTransfer', TkbTransfer);

    TkbTransfer.$inject = ['$resource', 'DateUtils'];

    function TkbTransfer ($resource, DateUtils) {
        var resourceUrl =  'api/tkb-transfers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getTransferState': {url: 'api/transfer-state/:externalId', method: 'GET'},
            'confirmTransfer': {url: 'api/transfer-confirm/:externalId', method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getGatewayDiagnostics': { url: 'api/gateway/diagnostics', method: 'GET' }
        });
    }
})();
